export const redirectTypes = ['permanent', 'temporary'];
